var _rect, _mask, _path, _path2, _rect2, _path3, _path4, _rect3, _path5, _path6, _rect4, _path7, _path8, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _ellipse, _path9, _path10, _path11, _rect12, _rect13, _rect14, _rect15, _rect16, _ellipse2, _path12, _path13, _path14, _rect17, _rect18, _rect19, _rect20, _rect21, _ellipse3, _path15, _path16, _path17, _rect22, _ellipse4, _rect23, _ellipse5, _rect24, _ellipse6, _path18, _rect25, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLandingImage3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 368 276",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 368,
    height: 276,
    rx: 8,
    fill: "#FFA1A1"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 368,
    height: 276
  }, /*#__PURE__*/React.createElement("rect", {
    width: 368,
    height: 276,
    rx: 8,
    fill: "#FF8080"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.315 64.4219C67.1653 68.1206 61.9624 74.9517 61.2942 82.2878C61.1102 84.3081 60.8479 87.7353 63.1858 88.622C66.3147 89.8088 70.8019 89.7595 74.0879 89.5559C78.7327 89.2682 81.4196 87.6794 82.2645 83.2217C83.0473 79.0914 78.5691 77.2266 75.3286 79.5267C72.5755 81.4808 69.054 88.0739 71.2403 91.4643C74.4632 96.4621 84.0361 94.6443 89.0172 96.2354C94.1247 97.8667 94.5467 103.499 93.7361 107.95C92.7515 113.355 88.8445 119.051 85.3968 123.258",
    stroke: "#FFA1A1",
    strokeWidth: 1.36327,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "1.95 5.84"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73.315 64.4219C67.1653 68.1206 61.9624 74.9517 61.2942 82.2878C61.1102 84.3081 60.8479 87.7353 63.1858 88.622C66.3147 89.8088 70.8019 89.7595 74.0879 89.5559C78.7327 89.2682 81.4196 87.6794 82.2645 83.2217C83.0473 79.0914 78.5691 77.2266 75.3286 79.5267C72.5755 81.4808 69.054 88.0739 71.2403 91.4643C74.4632 96.4621 84.0361 94.6443 89.0172 96.2354C94.1247 97.8667 94.5467 103.499 93.7361 107.95C92.7515 113.355 88.8445 119.051 85.3968 123.258",
    stroke: "#FFA1A1",
    strokeWidth: 1.36327,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "1.95 5.84"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.390344,
    y: 0.676097,
    width: 43.7112,
    height: 43.6396,
    rx: 7.44771,
    transform: "matrix(0.966045 0.258373 -0.259266 0.965806 62.3878 21.6781)",
    fill: "white",
    stroke: "#F0F4F7",
    strokeWidth: 1.10457
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M148.632 65.524C145.845 65.524 142.881 65.2473 140.211 66.194C136.214 67.6113 131.782 71.2531 130.062 75.1878C128.254 79.3226 129.809 81.4299 133.926 82.659C138.349 83.9794 144.02 87.4554 148.632 86.6269C150.04 86.3738 150.382 83.0688 151.195 81.9687C151.913 80.9953 146.985 78.7428 146.63 78.7976C145.713 78.939 143.157 80.4722 143.268 81.9687C143.392 83.6375 147.563 91.4049 148.632 91.6599C152.152 92.5001 157.359 87.7327 160.632 89.2572C162.729 90.2338 162.721 92.57 162.463 94.5967C161.615 101.26 154.099 102.794 149.547 106.169C145.45 109.206 144.658 115.503 144.604 120.218C144.576 122.735 144.079 125.782 147.167 126.552",
    stroke: "#FFA1A1",
    strokeWidth: 1.36327,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "1.95 5.84"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M148.632 65.524C145.845 65.524 142.881 65.2473 140.211 66.194C136.214 67.6113 131.782 71.2531 130.062 75.1878C128.254 79.3226 129.809 81.4299 133.926 82.659C138.349 83.9794 144.02 87.4554 148.632 86.6269C150.04 86.3738 150.382 83.0688 151.195 81.9687C151.913 80.9953 146.985 78.7428 146.63 78.7976C145.713 78.939 143.157 80.4722 143.268 81.9687C143.392 83.6375 147.563 91.4049 148.632 91.6599C152.152 92.5001 157.359 87.7327 160.632 89.2572C162.729 90.2338 162.721 92.57 162.463 94.5967C161.615 101.26 154.099 102.794 149.547 106.169C145.45 109.206 144.658 115.503 144.604 120.218C144.576 122.735 144.079 125.782 147.167 126.552",
    stroke: "#FFA1A1",
    strokeWidth: 1.36327,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "1.95 5.84"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 124.752,
    y: 26.7828,
    width: 43.7168,
    height: 43.634,
    rx: 7.44771,
    fill: "white",
    stroke: "#F0F4F7",
    strokeWidth: 1.10457
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M219.493 63.6992C226.791 63.6992 238.325 64.5558 238.816 74.236C239.155 80.9163 235.22 87.5452 228.646 89.5642C224.478 90.8442 222.788 88.1497 222.788 84.3668C222.788 80.9322 229.258 80.0977 231.575 81.7681C235.522 84.6135 234.369 92.858 233.772 96.9542C233.34 99.9166 232.42 105.217 234.565 107.714C237.159 110.736 241.915 111.991 245.569 111.991C249.455 111.991 251.789 109.714 254.274 106.821C255.134 105.869 257.19 103.854 258.535 103.406C260.215 102.847 266.939 102.288 265.258 110.676C263.913 117.387 263.95 117.201 264.137 116.269",
    stroke: "#FFA1A1",
    strokeWidth: 1.36327,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "1.95 5.84"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M219.493 63.6992C226.791 63.6992 238.325 64.5558 238.816 74.236C239.155 80.9163 235.22 87.5452 228.646 89.5642C224.478 90.8442 222.788 88.1497 222.788 84.3668C222.788 80.9322 229.258 80.0977 231.575 81.7681C235.522 84.6135 234.369 92.858 233.772 96.9542C233.34 99.9166 232.42 105.217 234.565 107.714C237.159 110.736 241.915 111.991 245.569 111.991C249.455 111.991 251.789 109.714 254.274 106.821C255.134 105.869 257.19 103.854 258.535 103.406C260.215 102.847 266.939 102.288 265.258 110.676C263.913 117.387 263.95 117.201 264.137 116.269",
    stroke: "#FFA1A1",
    strokeWidth: 1.36327,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "1.95 5.84"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 0.75504,
    y: 0.202312,
    width: 43.6961,
    height: 43.6548,
    rx: 7.44771,
    transform: "matrix(0.866425 -0.499307 0.500693 0.865625 184 41.1757)",
    fill: "white",
    stroke: "#F0F4F7",
    strokeWidth: 1.10457
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M301.212 64.4531C303.831 64.4531 305.317 67.8964 307.131 70.0689C308.266 71.4287 303.309 73.418 301.721 74.5431C297.564 77.488 297.856 76.808 293.077 78.421C291.002 79.1211 287.023 79.6829 286.405 82.2378C285.66 85.3202 286.245 89.6549 288.846 91.6986C291.757 93.9864 296.336 94.1413 299.85 94.0334C302.382 93.9556 306.008 92.5384 301.721 91.1505C299.859 90.5477 297.354 90.5474 295.416 90.8053C293.918 91.0046 293.417 93.2417 293.239 94.5003C292.97 96.4097 292.778 99.3698 293.605 101.159C294.64 103.397 297.39 103.909 298.65 105.829C301.945 110.85 290.93 117.318 287.87 118.904C284.555 120.62 280.84 121.19 277.415 122.558",
    stroke: "#FFA1A1",
    strokeWidth: 1.36327,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "1.95 5.84"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M301.212 64.4531C303.831 64.4531 305.317 67.8964 307.131 70.0689C308.266 71.4287 303.309 73.418 301.721 74.5431C297.564 77.488 297.856 76.808 293.077 78.421C291.002 79.1211 287.023 79.6829 286.405 82.2378C285.66 85.3202 286.245 89.6549 288.846 91.6986C291.757 93.9864 296.336 94.1413 299.85 94.0334C302.382 93.9556 306.008 92.5384 301.721 91.1505C299.859 90.5477 297.354 90.5474 295.416 90.8053C293.918 91.0046 293.417 93.2417 293.239 94.5003C292.97 96.4097 292.778 99.3698 293.605 101.159C294.64 103.397 297.39 103.909 298.65 105.829C301.945 110.85 290.93 117.318 287.87 118.904C284.555 120.62 280.84 121.19 277.415 122.558",
    stroke: "#FFA1A1",
    strokeWidth: 1.36327,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "1.95 5.84"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 0.632565,
    y: 0.458531,
    width: 43.7147,
    height: 43.6361,
    rx: 7.44771,
    transform: "matrix(0.987562 -0.157229 0.157796 0.987472 267.886 30.1579)",
    fill: "white",
    stroke: "#F0F4F7",
    strokeWidth: 1.10457
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 34.8801,
    y: 110.784,
    width: 298.24,
    height: 298.24,
    rx: 7.61988,
    fill: "white",
    stroke: "#F0F4F7",
    strokeWidth: 0.760234
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 52.8994,
    y: 223.105,
    width: 73.6,
    height: 3.45,
    fill: "#F6F8FA"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 52.8994,
    y: 228.855,
    width: 57.5,
    height: 3.45,
    fill: "#F6F8FA"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 52.8994,
    y: 239.205,
    width: 33.35,
    height: 2.3,
    fill: "#EBEDEE"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 52.8994,
    y: 211.605,
    width: 37.95,
    height: 4.6,
    fill: "#D5E6FD"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 52.8994,
    y: 155.254,
    width: 82.8,
    height: 46.575,
    rx: 3.6,
    fill: "#FFC370"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 94.2987,
    cy: 169.743,
    rx: 8.34456,
    ry: 8.28,
    fill: "#FFC370"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M94.2941 180.092C81.5281 180.092 70.994 189.573 69.4541 201.827H119.134C117.594 189.573 107.06 180.092 94.2941 180.092Z",
    fill: "#FFC370"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5024 192.908C99.6974 194.096 100.769 195.005 102.062 195.005C103.342 195.005 104.405 194.114 104.615 192.944C104.642 192.834 104.653 192.746 104.65 192.671C104.65 192.584 104.586 192.518 104.497 192.518H104.352H99.7964H99.6297C99.5406 192.518 99.4763 192.584 99.4762 192.67C99.476 192.67 99.4758 192.67 99.4756 192.67C99.4757 192.672 99.4758 192.674 99.476 192.676C99.4736 192.742 99.4822 192.817 99.5024 192.908L99.5024 192.908Z",
    fill: "#FFC370"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M103.329 196.528C103.232 195.934 102.696 195.479 102.05 195.479C101.41 195.479 100.878 195.924 100.773 196.51C100.759 196.565 100.754 196.609 100.756 196.646C100.756 196.689 100.788 196.723 100.832 196.723H100.905H103.182H103.266C103.31 196.723 103.342 196.689 103.342 196.646C103.343 196.646 103.343 196.646 103.343 196.646C103.343 196.645 103.343 196.644 103.343 196.643C103.344 196.611 103.339 196.573 103.329 196.528Z",
    fill: "#FFC370"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 142.601,
    y: 223.105,
    width: 73.6,
    height: 3.45,
    fill: "#F6F8FA"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 142.601,
    y: 228.855,
    width: 57.5,
    height: 3.45,
    fill: "#F6F8FA"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 142.601,
    y: 239.205,
    width: 33.35,
    height: 2.3,
    fill: "#EBEDEE"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 142.601,
    y: 211.605,
    width: 37.95,
    height: 4.6,
    fill: "#D5E6FD"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 142.601,
    y: 155.254,
    width: 82.8,
    height: 46.575,
    rx: 3.6,
    fill: "#FFA1A1"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8
  }, _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 183.998,
    cy: 169.743,
    rx: 8.34456,
    ry: 8.28,
    fill: "#FFA1A1"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M183.993 180.092C171.227 180.092 160.693 189.573 159.153 201.827H208.833C207.293 189.573 196.759 180.092 183.993 180.092Z",
    fill: "#FFA1A1"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M189.203 192.908C189.398 194.096 190.469 195.005 191.762 195.005C193.042 195.005 194.105 194.114 194.315 192.944C194.342 192.834 194.354 192.746 194.35 192.671C194.35 192.584 194.286 192.518 194.197 192.518H194.052H189.497H189.33C189.241 192.518 189.176 192.584 189.176 192.67C189.176 192.67 189.176 192.67 189.176 192.67C189.176 192.672 189.176 192.674 189.176 192.676C189.174 192.742 189.182 192.817 189.203 192.908L189.203 192.908Z",
    fill: "#FFA1A1"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M193.031 196.528C192.933 195.934 192.397 195.479 191.751 195.479C191.111 195.479 190.579 195.924 190.474 196.51C190.461 196.565 190.455 196.609 190.457 196.646C190.457 196.689 190.489 196.723 190.533 196.723H190.606H192.884H192.967C193.011 196.723 193.044 196.689 193.044 196.646C193.044 196.646 193.044 196.646 193.044 196.646C193.044 196.645 193.044 196.644 193.044 196.643C193.045 196.611 193.041 196.573 193.031 196.528Z",
    fill: "#FFA1A1"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 232.3,
    y: 223.105,
    width: 73.6,
    height: 3.45,
    fill: "#F6F8FA"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 232.3,
    y: 228.855,
    width: 57.5,
    height: 3.45,
    fill: "#F6F8FA"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 232.3,
    y: 239.205,
    width: 33.35,
    height: 2.3,
    fill: "#EBEDEE"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 232.3,
    y: 211.605,
    width: 37.95,
    height: 4.6,
    fill: "#D5E6FD"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 232.3,
    y: 155.254,
    width: 82.8,
    height: 46.575,
    rx: 3.6,
    fill: "#70AAFC"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8
  }, _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 273.698,
    cy: 169.743,
    rx: 8.34456,
    ry: 8.28,
    fill: "#70AAFC"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M273.694 180.092C260.928 180.092 250.393 189.573 248.854 201.827H298.534C296.994 189.573 286.459 180.092 273.694 180.092Z",
    fill: "#70AAFC"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M278.902 192.908C279.097 194.096 280.169 195.005 281.461 195.005C282.741 195.005 283.804 194.114 284.015 192.944C284.042 192.834 284.053 192.746 284.049 192.671C284.049 192.584 283.985 192.518 283.896 192.518H283.751H279.196H279.029C278.94 192.518 278.876 192.584 278.876 192.67C278.875 192.67 278.875 192.67 278.875 192.67C278.875 192.672 278.875 192.674 278.875 192.676C278.873 192.742 278.882 192.817 278.902 192.908L278.902 192.908Z",
    fill: "#70AAFC"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M282.73 196.528C282.632 195.934 282.096 195.479 281.45 195.479C280.81 195.479 280.279 195.924 280.173 196.51C280.16 196.565 280.154 196.609 280.156 196.646C280.156 196.689 280.188 196.723 280.233 196.723H280.305H282.583H282.666C282.711 196.723 282.743 196.689 282.743 196.646C282.743 196.646 282.743 196.646 282.743 196.646C282.743 196.645 282.743 196.644 282.743 196.643C282.744 196.611 282.74 196.573 282.73 196.528Z",
    fill: "#70AAFC"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 52.8994,
    y: 255.305,
    width: 82.8,
    height: 46.575,
    rx: 3.6,
    fill: "#70AAFC"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8
  }, _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 94.2987,
    cy: 269.792,
    rx: 8.34456,
    ry: 8.28,
    fill: "#70AAFC"
  }))), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 142.601,
    y: 255.305,
    width: 82.8,
    height: 46.575,
    rx: 3.6,
    fill: "#1BD697"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8
  }, _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 183.998,
    cy: 269.792,
    rx: 8.34456,
    ry: 8.28,
    fill: "#1BD697"
  }))), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 232.3,
    y: 255.305,
    width: 82.8,
    height: 46.575,
    rx: 3.6,
    fill: "#FFC370"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8
  }, _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 273.698,
    cy: 269.794,
    rx: 8.34456,
    ry: 8.28,
    fill: "#FFC370"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8801 118.404C34.8801 114.196 38.2917 110.784 42.5 110.784H325.5C329.708 110.784 333.12 114.196 333.12 118.404V144.995H34.8801V118.404Z",
    fill: "white",
    stroke: "#F0F4F7",
    strokeWidth: 0.760234
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 295.533,
    y: 119.646,
    width: 16.4854,
    height: 16.4854,
    rx: 2.54094,
    stroke: "#F0F4F7"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M55.556 123.701C56.083 126.913 58.9799 129.369 62.4745 129.369C65.9338 129.369 68.8074 126.962 69.3763 123.798C69.4492 123.501 69.4793 123.263 69.4701 123.06C69.4701 122.827 69.2963 122.646 69.0552 122.646H68.6642H56.3505H55.8999C55.659 122.646 55.4853 122.827 55.485 123.06C55.4845 123.06 55.4839 123.06 55.4834 123.06C55.4837 123.065 55.4841 123.07 55.4844 123.075C55.4781 123.252 55.5013 123.455 55.556 123.701L55.556 123.701Z",
    fill: "#2D81F7"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M65.909 133.485C65.6455 131.879 64.1971 130.65 62.4498 130.65C60.7201 130.65 59.2833 131.854 58.9989 133.436C58.9624 133.585 58.9474 133.703 58.952 133.805C58.952 133.921 59.0389 134.012 59.1594 134.012H59.3549H65.5118H65.7371C65.8575 134.012 65.9444 133.921 65.9445 133.805C65.9448 133.805 65.945 133.805 65.9453 133.805C65.9451 133.803 65.945 133.8 65.9448 133.797C65.948 133.709 65.9364 133.607 65.909 133.485Z",
    fill: "#08BD80"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M132.25 53.4796H138.777V51.1474H134.886V43.6816H132.25V53.4796Z",
    fill: "#FF7272"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M139.798 53.4796H142.462V43.6816H139.798V53.4796Z",
    fill: "#FF7272"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M149.881 43.6816L147.99 49.7398H147.963L146.1 43.6816H143.243L146.831 53.4796H149.136L152.71 43.6816H149.881Z",
    fill: "#FF7272"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M153.421 53.4796H160.225V51.1474H155.961V49.7674H159.066V47.4904H155.961V46.0138H159.935V43.6816H153.421V53.4796Z",
    fill: "#FF7272"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M207.292 59.9642L209.492 58.6965L207.997 56.1018L208.954 55.5506C210.915 54.4208 211.631 52.7339 210.522 50.8088C209.516 49.063 207.829 48.3467 205.701 49.5731L202.4 51.4746L207.292 59.9642ZM206.867 54.1408L205.751 52.2038L206.349 51.8593C207.174 51.3839 207.835 51.5921 208.139 52.1182C208.504 52.7519 208.194 53.3761 207.465 53.7964L206.867 54.1408Z",
    fill: "#FF7272"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M214.508 55.8062L217.605 54.0218C220.355 52.4372 220.971 49.7734 219.531 47.2743C218.084 44.7633 215.356 44.0097 212.678 45.5529L209.617 47.3166L214.508 55.8062ZM215.544 52.5178L212.981 48.0697L213.89 47.5461C215.002 46.9054 216.421 47.3779 217.151 48.6453C217.854 49.865 217.577 51.3466 216.285 52.0906L215.544 52.5178Z",
    fill: "#FF7272"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M222.962 50.9351L225.163 49.6674L223.516 46.8097L226.493 45.0942L225.336 43.0853L222.358 44.8008L221.435 43.1986L225.07 41.1042L223.906 39.0834L218.071 42.4455L222.962 50.9351Z",
    fill: "#FF7272"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4663 51.2879L70.7408 50.2082C71.3804 49.5793 71.8725 48.7538 72.1434 47.7406C72.9205 44.8343 71.4217 42.3194 68.5421 41.5494C65.6225 40.7687 63.0747 42.2302 62.3047 45.1099C61.5347 47.9895 63.0166 50.5142 65.9363 51.2948C67.0295 51.5872 68.0775 51.5674 69.0031 51.2578L69.829 52.55L71.4663 51.2879ZM66.5672 48.9351C65.2341 48.5787 64.5834 47.2191 64.9577 45.8192C65.332 44.4194 66.5744 43.566 67.9076 43.9224C69.2541 44.2825 69.8745 45.6483 69.5038 47.0348C69.4254 47.3281 69.3105 47.5974 69.1592 47.8426L68.6495 47.0778L67.0539 48.2368L67.537 48.9945C67.225 49.0396 66.9005 49.0243 66.5672 48.9351Z",
    fill: "#FF7272"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9045 53.9602C78.5042 54.6554 80.3522 53.4068 81.0152 50.9271L82.4839 45.4344L79.9376 44.7536L78.5081 50.0996C78.1837 51.3127 77.3753 51.8251 76.5354 51.6005C75.5622 51.3403 75.3611 50.3294 75.6285 49.3296L77.0579 43.9836L74.4983 43.2992L73.0296 48.7918C72.3166 51.4581 73.5315 53.3257 75.9045 53.9602Z",
    fill: "#FF7272"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3315 55.2685L83.9045 55.9565L86.4355 46.491L83.8625 45.803L81.3315 55.2685Z",
    fill: "#FF7272"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3332 50.6455L94.843 48.7391L87.7505 46.8427L87.1481 49.0957L90.8543 50.0867L90.8436 50.1267L85.6272 54.303L85.0996 56.276L92.312 58.2046L92.9145 55.9515L88.9416 54.8892L88.9452 54.8759L94.3332 50.6455Z",
    fill: "#FF7272"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M282.316 55.7273L284.892 55.317L283.717 47.9442L286.17 47.5535L285.804 45.2503L278.322 46.442L278.689 48.7452L281.142 48.3544L282.316 55.7273Z",
    fill: "#FF7272"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M288.285 54.7766L295.004 53.7064L294.637 51.4033L290.426 52.074L290.209 50.7112L293.275 50.2228L292.917 47.9741L289.85 48.4625L289.618 47.0043L293.543 46.3791L293.176 44.076L286.744 45.1005L288.285 54.7766Z",
    fill: "#FF7272"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M299.117 53.191C300.739 52.9327 302.645 51.8325 302.259 49.4066C301.962 47.5396 300.6 47.3233 298.778 46.9427C297.736 46.7174 297.491 46.491 297.439 46.1639C297.384 45.8232 297.565 45.5568 298.029 45.483C298.506 45.407 299.058 45.5426 300.007 46.0622L301.145 43.9944C300.118 43.3336 298.85 43.0046 297.519 43.2446C295.672 43.5807 294.493 45.0401 294.755 46.6891C295.07 48.6652 296.655 49.1394 298.207 49.4093C299.297 49.585 299.52 49.759 299.581 50.1406C299.629 50.4404 299.449 50.8044 298.85 50.8999C298.25 50.9954 297.357 50.8302 296.47 50.1749L295.285 52.2083C296.49 53.1063 297.863 53.3907 299.117 53.191Z",
    fill: "#FF7272"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M305.713 52.0007L308.289 51.5904L307.114 44.2175L309.567 43.8268L309.2 41.5237L301.719 42.7154L302.085 45.0185L304.538 44.6278L305.713 52.0007Z",
    fill: "#FF7272"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandingImage3);
export default __webpack_public_path__ + "static/media/landing_image_3.cf0e93c4ffc99029d12f5813f24bef33.svg";
export { ForwardRef as ReactComponent };